export const FormWarningBanner = () => {
  return (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
      <div className="flex">
        <div className="ml-3">
          <p className="text-sm text-yellow-700">
            This form is for creating employee accounts only. Employees will have access to the admin dashboard.
            For regular client accounts, please use the client registration form.
          </p>
        </div>
      </div>
    </div>
  );
};